import * as fromDatatype from "../datatype-library/index";

export interface bl_mkp_seller_order_lines_RowInterface {
     guid: fromDatatype.GuidDataFieldInterface;
     fi_gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
     fi_gendoc_line_guid: fromDatatype.GuidDataFieldInterface;
     hdr_guid: fromDatatype.GuidDataFieldInterface;
     server_doc_type: fromDatatype.VarcharDatatypeInterface;
     status: fromDatatype.VarcharDatatypeInterface;
     client_doc_type: fromDatatype.VarcharDatatypeInterface;
     client_key: fromDatatype.VarcharDatatypeInterface;
     client_source: fromDatatype.VarcharDatatypeInterface;
     client_value: fromDatatype.VarcharDatatypeInterface;
     client_hashed_value: fromDatatype.VarcharDatatypeInterface;
     client_data_source: fromDatatype.VarcharDatatypeInterface;
     client_item_guid: fromDatatype.GuidDataFieldInterface;
     client_item_code: fromDatatype.VarcharDatatypeInterface;
     client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
     client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
     client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
     client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
     client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
     reference_no: fromDatatype.VarcharDatatypeInterface;
     base_doc_line_guid: fromDatatype.GuidDataFieldInterface;
     base_doc_line_ccy : fromDatatype.VarcharDatatypeInterface;
     base_doc_line_xrate: fromDatatype.NumericDatatypeInterface;
     foreign_ccy: fromDatatype.VarcharDatatypeInterface;
     doc_ccy: fromDatatype.VarcharDatatypeInterface;
     qty_reserve_adj: fromDatatype.NumericDatatypeInterface;
     txn_type: fromDatatype.VarcharDatatypeInterface;
     txn_code: fromDatatype.VarcharDatatypeInterface;

     date_txn: fromDatatype.TimestampTzDatatypeInterface;
     position_id: fromDatatype.VarcharDatatypeInterface;
     log_json : any;
     t2t_seller_env_code: fromDatatype.VarcharDatatypeInterface;
     t2t_seller_tenant_code: fromDatatype.VarcharDatatypeInterface;
     t2t_seller_gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
     t2t_seller_gendoc_line_guid: fromDatatype.GuidDataFieldInterface;
     guid_parent: fromDatatype.GuidDataFieldInterface;
     guid_comp: fromDatatype.GuidDataFieldInterface;
     guid_branch: fromDatatype.GuidDataFieldInterface;
     guid_store: fromDatatype.GuidDataFieldInterface;
     guid_store_2: fromDatatype.GuidDataFieldInterface;
     guid_profit_center: fromDatatype.GuidDataFieldInterface;
     guid_segment: fromDatatype.GuidDataFieldInterface;
     guid_project: fromDatatype.GuidDataFieldInterface;
     guid_dimension: fromDatatype.GuidDataFieldInterface;
     guid_glcode: fromDatatype.GuidDataFieldInterface;
     entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
     entity_line_guid: fromDatatype.GuidDataFieldInterface;
     entity_fi_item_link_guid: fromDatatype.GuidDataFieldInterface;
     entity_inv_item_link_guid: fromDatatype.GuidDataFieldInterface;
     entity_json : any;
     coupon_hdr_guid: fromDatatype.GuidDataFieldInterface;
     coupon_line_guid: fromDatatype.GuidDataFieldInterface;
     membership_ext_start_date: fromDatatype.TimestampTzDatatypeInterface;
     point_type: fromDatatype.VarcharDatatypeInterface;
     point_amount: fromDatatype.NumericDatatypeInterface;
     point_currency: fromDatatype.VarcharDatatypeInterface;
     point_start_date: fromDatatype.TimestampTzDatatypeInterface;
     point_end_date: fromDatatype.TimestampTzDatatypeInterface;
     payment_channel_name: fromDatatype.VarcharDatatypeInterface;
     parent_fi_item_guid: fromDatatype.GuidDataFieldInterface;
     item_guid: fromDatatype.GuidDataFieldInterface;
     mkp_item_guid: fromDatatype.GuidDataFieldInterface;
     item_txn_type: fromDatatype.VarcharDatatypeInterface;
     item_sub_type: fromDatatype.VarcharDatatypeInterface;
     item_code: fromDatatype.VarcharDatatypeInterface;
     mkp_item_code: fromDatatype.VarcharDatatypeInterface;
     item_machine_code: fromDatatype.VarcharDatatypeInterface;
     item_name: fromDatatype.VarcharDatatypeInterface;
     item_desc: fromDatatype.VarcharDatatypeInterface;
     item_remarks: fromDatatype.VarcharDatatypeInterface;
     item_reference_no: fromDatatype.VarcharDatatypeInterface;
     item_custom_template_json: any;
     item_custom_data_json: any;
     item_property_json: any;
     item_child_json: any;
     item_to_item_link_json: any;
     sort_code: fromDatatype.VarcharDatatypeInterface;
     line_option_json: any;
     line_property_json: any;
     label_json: any;
     serial_no: any;
     batch_no: any;
     bin_no: any;
     posting_fulfillment: fromDatatype.VarcharDatatypeInterface;
     posting_bundle: fromDatatype.VarcharDatatypeInterface;
     posting_mto: fromDatatype.VarcharDatatypeInterface;
     unit_price_std: fromDatatype.NumericDatatypeInterface;
     unit_discount: fromDatatype.NumericDatatypeInterface;
     quantity_base: fromDatatype.NumericDatatypeInterface;
     uom: fromDatatype.VarcharDatatypeInterface;
     uom_to_base_ratio: fromDatatype.NumericDatatypeInterface;
     unit_price_std_by_uom: fromDatatype.NumericDatatypeInterface;
     unit_price_std_by_uom_incl_tax: fromDatatype.NumericDatatypeInterface;
     unit_disc_by_uom: fromDatatype.NumericDatatypeInterface;
     unit_price_by_uom: fromDatatype.NumericDatatypeInterface;
     unit_price_txn_by_uom: fromDatatype.NumericDatatypeInterface;
     qty_by_uom: fromDatatype.NumericDatatypeInterface;
     uom_json: any;
     unit_price_net: fromDatatype.NumericDatatypeInterface;
     amount_std: fromDatatype.NumericDatatypeInterface;
     amount_discount: fromDatatype.NumericDatatypeInterface;
     multi_level_disc_json: any;
     amount_net: fromDatatype.NumericDatatypeInterface;
     tax_gst_code: fromDatatype.VarcharDatatypeInterface;
     tax_gst_type: fromDatatype.VarcharDatatypeInterface;
     tax_gst_rate: fromDatatype.NumericDatatypeInterface;
     amount_tax_gst: fromDatatype.NumericDatatypeInterface;
     tax_wht_type: fromDatatype.VarcharDatatypeInterface;
     tax_wht_code: fromDatatype.VarcharDatatypeInterface;
     tax_wht_rate: fromDatatype.NumericDatatypeInterface;
     tax_tariff_code: fromDatatype.GuidDataFieldInterface;
     tax_industry_code: fromDatatype.GuidDataFieldInterface;
     amount_tax_wht: fromDatatype.NumericDatatypeInterface;
     unit_price_txn: fromDatatype.NumericDatatypeInterface;
     amount_txn: fromDatatype.NumericDatatypeInterface;
     qty_open: fromDatatype.NumericDatatypeInterface;
     quantity_signum: fromDatatype.NumericDatatypeInterface;
     amount_signum: fromDatatype.NumericDatatypeInterface;
     amount_open_balance: fromDatatype.NumericDatatypeInterface;
     amount_cogs: fromDatatype.NumericDatatypeInterface;
     amount_json: any;
     cost_ma_amount: fromDatatype.NumericDatatypeInterface;
     cost_ma_price: fromDatatype.NumericDatatypeInterface;
     cost_wa_amount: fromDatatype.NumericDatatypeInterface;
     cost_wa_price: fromDatatype.NumericDatatypeInterface;
     cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
     cost_fifo_price: fromDatatype.NumericDatatypeInterface;
     cost_lifo_amount: fromDatatype.NumericDatatypeInterface;
     cost_lifo_price: fromDatatype.NumericDatatypeInterface;
     cost_manual_amount: fromDatatype.NumericDatatypeInterface;
     cost_manual_price: fromDatatype.NumericDatatypeInterface;
     cost_replacement_amount: fromDatatype.NumericDatatypeInterface;
     cost_replacement_price: fromDatatype.NumericDatatypeInterface;
     cost_last_purchase_location: fromDatatype.NumericDatatypeInterface;
     cost_last_purchase_company: fromDatatype.NumericDatatypeInterface;
     landed_txn_amount: fromDatatype.NumericDatatypeInterface;
     landed_txn_price: fromDatatype.NumericDatatypeInterface;
     landed_cost_ma_price: fromDatatype.NumericDatatypeInterface;
     landed_cost_ma_amount: fromDatatype.NumericDatatypeInterface;
     landed_cost_wa_amount: fromDatatype.NumericDatatypeInterface;
     landed_cost_wa_price: fromDatatype.NumericDatatypeInterface;
     landed_cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
     landed_cost_fifo_price: fromDatatype.NumericDatatypeInterface;
     landed_cost_lifo_amount: fromDatatype.NumericDatatypeInterface;
     landed_cost_lifo_price: fromDatatype.NumericDatatypeInterface;
     del_region_hdr_guid: fromDatatype.GuidDataFieldInterface;
     del_region_hdr_reg_code: fromDatatype.VarcharDatatypeInterface;
     del_region_hdr_state: fromDatatype.NumericDatatypeInterface;
     delivery_required: fromDatatype.NumericDatatypeInterface;
     delivery_option :any;
     cfg_delivery: fromDatatype.VarcharDatatypeInterface;
     cfg_production: fromDatatype.VarcharDatatypeInterface;
     ready_to_ship: fromDatatype.VarcharDatatypeInterface;
     tracking_id: fromDatatype.VarcharDatatypeInterface;
     track_delivery_guid: fromDatatype.GuidDataFieldInterface;
     track_delivery_id: fromDatatype.VarcharDatatypeInterface;
     track_delivery_logic: fromDatatype.VarcharDatatypeInterface;
     track_delivery_table: fromDatatype.VarcharDatatypeInterface;
     track_delivery_date_requested: fromDatatype.TimestampTzDatatypeInterface;
     track_delivery_time_estimated: fromDatatype.TimestampTzDatatypeInterface;
     track_delivery_time_actual: fromDatatype.TimestampTzDatatypeInterface;
     track_delivery_time_planned: fromDatatype.TimestampTzDatatypeInterface;
     track_delivery_pic_name: fromDatatype.VarcharDatatypeInterface;
     track_delivery_pic_contact: fromDatatype.VarcharDatatypeInterface;
     track_delivery_remarks: fromDatatype.VarcharDatatypeInterface;
     track_delivery_status: fromDatatype.VarcharDatatypeInterface;
     track_production_guid: fromDatatype.GuidDataFieldInterface;
     track_production_id: fromDatatype.VarcharDatatypeInterface;
     track_production_logic: fromDatatype.VarcharDatatypeInterface;
     track_production_table: fromDatatype.VarcharDatatypeInterface;
     track_production_time_estimated: fromDatatype.TimestampTzDatatypeInterface;
     track_production_time_actual: fromDatatype.TimestampTzDatatypeInterface;
     track_production_time_plannedw: fromDatatype.TimestampTzDatatypeInterface;
     track_production_pic_name: fromDatatype.VarcharDatatypeInterface;
     track_production_pic_contact: fromDatatype.VarcharDatatypeInterface;
     track_production_remarks: fromDatatype.VarcharDatatypeInterface;
     track_production_status: fromDatatype.VarcharDatatypeInterface;
     delivery_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
     delivery_process_status_guid: fromDatatype.GuidDataFieldInterface;
     delivery_process_status_name: fromDatatype.VarcharDatatypeInterface;
     delivery_process_resolution_guid: fromDatatype.GuidDataFieldInterface;
     delivery_process_resolution_code: fromDatatype.VarcharDatatypeInterface;
     pickup_branch_guid: fromDatatype.GuidDataFieldInterface;
     pick_pack_queue: fromDatatype.VarcharDatatypeInterface;
     delivery_branch_guid: fromDatatype.GuidDataFieldInterface;
     delivery_branch_code: fromDatatype.VarcharDatatypeInterface;
     delivery_location_guid: fromDatatype.GuidDataFieldInterface;
     delivery_location_code: fromDatatype.VarcharDatatypeInterface;
     wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
     wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
     wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
     wf_resolution_guid: fromDatatype.VarcharDatatypeInterface;
     wf_resolution_code: fromDatatype.VarcharDatatypeInterface;
     acl_config: any;
     acl_policy: any;
     module_guid: fromDatatype.GuidDataFieldInterface;
     applet_guid: fromDatatype.GuidDataFieldInterface;
     namespace: fromDatatype.VarcharDatatypeInterface;
     revision: fromDatatype.GuidDataFieldInterface;
     vrsn: fromDatatype.VarcharDatatypeInterface;
     created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
     updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
     created_date: fromDatatype.TimestampTzDatatypeInterface;
     updated_date: fromDatatype.TimestampTzDatatypeInterface;
     marketplace_status: fromDatatype.VarcharDatatypeInterface;
     track_delivery_sub_status: fromDatatype.VarcharDatatypeInterface;
}

export class bl_mkp_seller_order_lines_RowClass implements bl_mkp_seller_order_lines_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    fi_gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    fi_gendoc_line_guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    client_doc_type: fromDatatype.VarcharDatatypeInterface;
    client_key: fromDatatype.VarcharDatatypeInterface;
    client_source: fromDatatype.VarcharDatatypeInterface;
    client_value: fromDatatype.VarcharDatatypeInterface;
    client_hashed_value: fromDatatype.VarcharDatatypeInterface;
    client_data_source: fromDatatype.VarcharDatatypeInterface;
    client_item_guid: fromDatatype.GuidDataFieldInterface;
    client_item_code: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
    reference_no: fromDatatype.VarcharDatatypeInterface;
    base_doc_line_guid: fromDatatype.GuidDataFieldInterface;
    base_doc_line_ccy : fromDatatype.VarcharDatatypeInterface;
    base_doc_line_xrate: fromDatatype.NumericDatatypeInterface;
    foreign_ccy: fromDatatype.VarcharDatatypeInterface;
    doc_ccy: fromDatatype.VarcharDatatypeInterface;
    qty_reserve_adj: fromDatatype.NumericDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    txn_code: fromDatatype.VarcharDatatypeInterface;

    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    position_id: fromDatatype.VarcharDatatypeInterface;
    log_json : any;
    t2t_seller_env_code: fromDatatype.VarcharDatatypeInterface;
    t2t_seller_tenant_code: fromDatatype.VarcharDatatypeInterface;
    t2t_seller_gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    t2t_seller_gendoc_line_guid: fromDatatype.GuidDataFieldInterface;
    guid_parent: fromDatatype.GuidDataFieldInterface;
    guid_comp: fromDatatype.GuidDataFieldInterface;
    guid_branch: fromDatatype.GuidDataFieldInterface;
    guid_store: fromDatatype.GuidDataFieldInterface;
    guid_store_2: fromDatatype.GuidDataFieldInterface;
    guid_profit_center: fromDatatype.GuidDataFieldInterface;
    guid_segment: fromDatatype.GuidDataFieldInterface;
    guid_project: fromDatatype.GuidDataFieldInterface;
    guid_dimension: fromDatatype.GuidDataFieldInterface;
    guid_glcode: fromDatatype.GuidDataFieldInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_line_guid: fromDatatype.GuidDataFieldInterface;
    entity_fi_item_link_guid: fromDatatype.GuidDataFieldInterface;
    entity_inv_item_link_guid: fromDatatype.GuidDataFieldInterface;
    entity_json : any;
    coupon_hdr_guid: fromDatatype.GuidDataFieldInterface;
    coupon_line_guid: fromDatatype.GuidDataFieldInterface;
    membership_ext_start_date: fromDatatype.TimestampTzDatatypeInterface;
    point_type: fromDatatype.VarcharDatatypeInterface;
    point_amount: fromDatatype.NumericDatatypeInterface;
    point_currency: fromDatatype.VarcharDatatypeInterface;
    point_start_date: fromDatatype.TimestampTzDatatypeInterface;
    point_end_date: fromDatatype.TimestampTzDatatypeInterface;
    payment_channel_name: fromDatatype.VarcharDatatypeInterface;
    parent_fi_item_guid: fromDatatype.GuidDataFieldInterface;
    item_guid: fromDatatype.GuidDataFieldInterface;
    mkp_item_guid: fromDatatype.GuidDataFieldInterface;
    item_txn_type: fromDatatype.VarcharDatatypeInterface;
    item_sub_type: fromDatatype.VarcharDatatypeInterface;
    item_code: fromDatatype.VarcharDatatypeInterface;
    mkp_item_code: fromDatatype.VarcharDatatypeInterface;
    item_machine_code: fromDatatype.VarcharDatatypeInterface;
    item_name: fromDatatype.VarcharDatatypeInterface;
    item_desc: fromDatatype.VarcharDatatypeInterface;
    item_remarks: fromDatatype.VarcharDatatypeInterface;
    item_reference_no: fromDatatype.VarcharDatatypeInterface;
    item_custom_template_json: any;
    item_custom_data_json: any;
    item_property_json: any;
    item_child_json: any;
    item_to_item_link_json: any;
    sort_code: fromDatatype.VarcharDatatypeInterface;
    line_option_json: any;
    line_property_json: any;
    label_json: any;
    serial_no: any;
    batch_no: any;
    bin_no: any;
    posting_fulfillment: fromDatatype.VarcharDatatypeInterface;
    posting_bundle: fromDatatype.VarcharDatatypeInterface;
    posting_mto: fromDatatype.VarcharDatatypeInterface;
    unit_price_std: fromDatatype.NumericDatatypeInterface;
    unit_discount: fromDatatype.NumericDatatypeInterface;
    quantity_base: fromDatatype.NumericDatatypeInterface;
    uom: fromDatatype.VarcharDatatypeInterface;
    uom_to_base_ratio: fromDatatype.NumericDatatypeInterface;
    unit_price_std_by_uom: fromDatatype.NumericDatatypeInterface;
    unit_price_std_by_uom_incl_tax: fromDatatype.NumericDatatypeInterface;
    unit_disc_by_uom: fromDatatype.NumericDatatypeInterface;
    unit_price_by_uom: fromDatatype.NumericDatatypeInterface;
    unit_price_txn_by_uom: fromDatatype.NumericDatatypeInterface;
    qty_by_uom: fromDatatype.NumericDatatypeInterface;
    uom_json: any;
    unit_price_net: fromDatatype.NumericDatatypeInterface;
    amount_std: fromDatatype.NumericDatatypeInterface;
    amount_discount: fromDatatype.NumericDatatypeInterface;
    multi_level_disc_json: any;
    amount_net: fromDatatype.NumericDatatypeInterface;
    tax_gst_code: fromDatatype.VarcharDatatypeInterface;
    tax_gst_type: fromDatatype.VarcharDatatypeInterface;
    tax_gst_rate: fromDatatype.NumericDatatypeInterface;
    amount_tax_gst: fromDatatype.NumericDatatypeInterface;
    tax_wht_type: fromDatatype.VarcharDatatypeInterface;
    tax_wht_code: fromDatatype.VarcharDatatypeInterface;
    tax_wht_rate: fromDatatype.NumericDatatypeInterface;
    tax_tariff_code: fromDatatype.GuidDataFieldInterface;
    tax_industry_code: fromDatatype.GuidDataFieldInterface;
    amount_tax_wht: fromDatatype.NumericDatatypeInterface;
    unit_price_txn: fromDatatype.NumericDatatypeInterface;
    amount_txn: fromDatatype.NumericDatatypeInterface;
    qty_open: fromDatatype.NumericDatatypeInterface;
    quantity_signum: fromDatatype.NumericDatatypeInterface;
    amount_signum: fromDatatype.NumericDatatypeInterface;
    amount_open_balance: fromDatatype.NumericDatatypeInterface;
    amount_cogs: fromDatatype.NumericDatatypeInterface;
    amount_json: any;
    cost_ma_amount: fromDatatype.NumericDatatypeInterface;
    cost_ma_price: fromDatatype.NumericDatatypeInterface;
    cost_wa_amount: fromDatatype.NumericDatatypeInterface;
    cost_wa_price: fromDatatype.NumericDatatypeInterface;
    cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
    cost_fifo_price: fromDatatype.NumericDatatypeInterface;
    cost_lifo_amount: fromDatatype.NumericDatatypeInterface;
    cost_lifo_price: fromDatatype.NumericDatatypeInterface;
    cost_manual_amount: fromDatatype.NumericDatatypeInterface;
    cost_manual_price: fromDatatype.NumericDatatypeInterface;
    cost_replacement_amount: fromDatatype.NumericDatatypeInterface;
    cost_replacement_price: fromDatatype.NumericDatatypeInterface;
    cost_last_purchase_location: fromDatatype.NumericDatatypeInterface;
    cost_last_purchase_company: fromDatatype.NumericDatatypeInterface;
    landed_txn_amount: fromDatatype.NumericDatatypeInterface;
    landed_txn_price: fromDatatype.NumericDatatypeInterface;
    landed_cost_ma_price: fromDatatype.NumericDatatypeInterface;
    landed_cost_ma_amount: fromDatatype.NumericDatatypeInterface;
    landed_cost_wa_amount: fromDatatype.NumericDatatypeInterface;
    landed_cost_wa_price: fromDatatype.NumericDatatypeInterface;
    landed_cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
    landed_cost_fifo_price: fromDatatype.NumericDatatypeInterface;
    landed_cost_lifo_amount: fromDatatype.NumericDatatypeInterface;
    landed_cost_lifo_price: fromDatatype.NumericDatatypeInterface;
    del_region_hdr_guid: fromDatatype.GuidDataFieldInterface;
    del_region_hdr_reg_code: fromDatatype.VarcharDatatypeInterface;
    del_region_hdr_state: fromDatatype.NumericDatatypeInterface;
    delivery_required: fromDatatype.NumericDatatypeInterface;
    delivery_option :any;
    cfg_delivery: fromDatatype.VarcharDatatypeInterface;
    cfg_production: fromDatatype.VarcharDatatypeInterface;
    ready_to_ship: fromDatatype.VarcharDatatypeInterface;
    tracking_id: fromDatatype.VarcharDatatypeInterface;
    track_delivery_guid: fromDatatype.GuidDataFieldInterface;
    track_delivery_id: fromDatatype.VarcharDatatypeInterface;
    track_delivery_logic: fromDatatype.VarcharDatatypeInterface;
    track_delivery_table: fromDatatype.VarcharDatatypeInterface;
    track_delivery_date_requested: fromDatatype.TimestampTzDatatypeInterface;
    track_delivery_time_estimated: fromDatatype.TimestampTzDatatypeInterface;
    track_delivery_time_actual: fromDatatype.TimestampTzDatatypeInterface;
    track_delivery_time_planned: fromDatatype.TimestampTzDatatypeInterface;
    track_delivery_pic_name: fromDatatype.VarcharDatatypeInterface;
    track_delivery_pic_contact: fromDatatype.VarcharDatatypeInterface;
    track_delivery_remarks: fromDatatype.VarcharDatatypeInterface;
    track_delivery_status: fromDatatype.VarcharDatatypeInterface;
    track_production_guid: fromDatatype.GuidDataFieldInterface;
    track_production_id: fromDatatype.VarcharDatatypeInterface;
    track_production_logic: fromDatatype.VarcharDatatypeInterface;
    track_production_table: fromDatatype.VarcharDatatypeInterface;
    track_production_time_estimated: fromDatatype.TimestampTzDatatypeInterface;
    track_production_time_actual: fromDatatype.TimestampTzDatatypeInterface;
    track_production_time_plannedw: fromDatatype.TimestampTzDatatypeInterface;
    track_production_pic_name: fromDatatype.VarcharDatatypeInterface;
    track_production_pic_contact: fromDatatype.VarcharDatatypeInterface;
    track_production_remarks: fromDatatype.VarcharDatatypeInterface;
    track_production_status: fromDatatype.VarcharDatatypeInterface;
    delivery_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
    delivery_process_status_guid: fromDatatype.GuidDataFieldInterface;
    delivery_process_status_name: fromDatatype.VarcharDatatypeInterface;
    delivery_process_resolution_guid: fromDatatype.GuidDataFieldInterface;
    delivery_process_resolution_code: fromDatatype.VarcharDatatypeInterface;
    pickup_branch_guid: fromDatatype.GuidDataFieldInterface;
    pick_pack_queue: fromDatatype.VarcharDatatypeInterface;
    delivery_branch_guid: fromDatatype.GuidDataFieldInterface;
    delivery_branch_code: fromDatatype.VarcharDatatypeInterface;
    delivery_location_guid: fromDatatype.GuidDataFieldInterface;
    delivery_location_code: fromDatatype.VarcharDatatypeInterface;
    wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
    wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
    wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
    wf_resolution_guid: fromDatatype.VarcharDatatypeInterface;
    wf_resolution_code: fromDatatype.VarcharDatatypeInterface;
    acl_config: any;
    acl_policy: any;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    marketplace_status: fromDatatype.VarcharDatatypeInterface;
    track_delivery_sub_status: fromDatatype.VarcharDatatypeInterface;
}